import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataOperation } from '../../../data/DataOperation';
import { Immocom } from '../../../specifique/immocom';

export class BandeauOperation extends Component {

    static defaultProps = {
        idOperation: undefined,
    };

    static defaultState = {
        operation: {},
    };

    constructor(props) {
        super(props);
        this.state = { ...BandeauOperation.defaultState };
    };

    _chargementDonnees = () => {
        const { idOperation } = this.props;
        DataOperation._chargementFicheOperation(idOperation).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const operation = responseFetch.reponseAPIobjet[0];
                const state = { operation };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });
    };

    componentDidMount = () => {
        const { idOperation } = this.props;
        if (!!idOperation)
            this._chargementDonnees();
    };

    componentDidUpdate = (prevProps) => {
        const { idOperation } = this.props;
        if (!!idOperation && idOperation !== prevProps.idOperation)
            this._chargementDonnees();
    };

    render = () => {

        const { operation } = this.state;
        const { adresse, certification, cp, dateLancementCommercialisation, dateLivraison, dateSignatureOSTravaux, email, flashCommercial, loginCompte, nom, nomCommercial, performanceEnergetique, prenom, tel, ville, zoneFiscale } = operation;

        const styles = {
            root: { margin: "5px 0 0 5px" },
            cadreOperation: {
                backgroundColor: "#fd0400", /* themePrimary */
                color: "#fff",
                fontSize: "14px",
                padding: "10px 18px",
            },
            nomOperation: { fontSize: "18px" },
            blocResponsableEI: { marginLeft: "15px" },
            nomResponsableEI: { fontWeight: 600 },
            cadreFlashCommercial: {
                borderLeft: "7px solid red",
                fontSize: "13px",
                margin: "10px 0",
                padding: "10px",
            },
            titreFlashCommercial: { fontWeight: 600 },
            cadreDates: {
                backgroundColor: "#ddd",
                fontSize: "12px",
                padding: "10px 18px",
            },
            livraison: {
                fontWeight: 600,
                marginBottom: "5px",
            },
        };
        const { root, cadreOperation, nomOperation, blocResponsableEI, nomResponsableEI, cadreFlashCommercial, titreFlashCommercial, cadreDates, livraison } = styles;

        return !!operation && !!operation.idOperation &&
            <div className="ms-Grid" style={root}>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-lg4" style={cadreOperation}>
                        <div style={nomOperation}>{nomCommercial} ({cp})</div>
                        <div>{adresse} - {ville}</div>
                        <div style={blocResponsableEI}>
                            <div style={nomResponsableEI}>Responsable EI : {nom} {prenom} ({loginCompte})</div>
                            <div>Email : {email}</div>
                            <div>Téléphone : {tel}</div>
                        </div>
                    </div>
                    <div className="ms-Grid-col ms-hiddenSm ms-sm12 ms-lg4">
                        <div style={cadreFlashCommercial}>
                            <div style={titreFlashCommercial}>Flash commercial</div>
                            <div>{flashCommercial}</div>
                        </div>
                    </div>
                    <div className="ms-Grid-col ms-hiddenSm ms-sm12 ms-lg4 ">
                        <div style={cadreDates}>
                            <div>Date commercialisation : {Scriba.date().stringDateFormatCourt(dateLancementCommercialisation)}</div>
                            <div>Date début travaux : {Scriba.date().stringDateFormatCourt(dateSignatureOSTravaux)}</div>
                            <div style={livraison}>Date livraison : {Scriba.date().stringDateFormatCourt(dateLivraison)}</div>
                            <div>Perf. énergétique : {performanceEnergetique}</div>
                            <div>Certification : {certification}</div>
                            <div>Zone fiscale : {zoneFiscale}</div>
                        </div>
                    </div>
                </div>
            </div>;

    };

};